.promo-codes {
	margin-top: 20px;
	border-radius: 5px;
	margin-top: 10px;
	display: flex;
	gap: 5px;
	align-items: stretch;
	flex-wrap: wrap;
	.promo-code {
		background: black;
		color: white;
		padding: 5px 10px;
		border-radius: 20px;
		font-size: smaller;
		width: fit-content;
		transition: 0.4s all ease-in-out;
		display: flex;
		align-items: center;
		span {
			text-transform: capitalize;
		}
		svg {
			margin-right: 5px;
		}
		&:hover {
			cursor: pointer;
			background: var(--emphasis-color-dark-2);
		}
		&.active {
			background: var(--emphasis-color);
		}
	}
}
